import React, { useEffect, useState } from 'react';
import { Pagination } from '../../../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { State } from '../../../../reducers';
import { Tooltip } from '@mui/material';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton';
import {
  gp_lp_OpenModalEliminarProducto,
  gp_lp_OpenModalEstatus,
  gp_lp_OpenModalSucursales,
  gp_lp_SetProductoSeleccionado
} from '../../../../actions/gestion-producto/lista-producto/listaProductos.actions';
import { actionsGPlistarProductos, actionsGPEditarProducto } from '../../../../actions/action-creators';
import Edit from '../../../../media/felsv/DarkEditPencil.svg';
import Recycle from '../../../../media/felsv/DarkRecycleDelete.svg';
import AddHome from '../../../../media/felsv/addhome.svg';
import Open_Eye from '../../../../media/felsv/Open_Eye.svg';
import Close_Eye from '../../../../media/felsv/Close_Eye.svg';
import '../styles/table-list-producto.css';

const TableListProducto = () => {
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [sortedData, setSortedData] = useState<any[]>([]);
  const productos = useSelector((state: State) => state.gestionProducto.listarProductos.productos);
  const formProductos = useSelector((state: State) => state.gestionProducto.listarProductos.formBuscar);
  const { unidadesMedida } = useSelector((state: State) => state.catalogos);

  const history = useHistory();
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionsGPlistarProductos, dispatch);
  const actionsEditar = bindActionCreators(actionsGPEditarProducto, dispatch);

  const getUnidadMedidaValor = (codigo: string) =>
    unidadesMedida.find(u => u.codigo === codigo)?.valor ?? codigo;

  const getTipoItemValor = (codigo: string) => {
    if (codigo === "0") return "Servicio";
    if (codigo === "1") return "Producto";
    return "---";
  };

  const filtrarProductos = () => {
    return productos.filter(p => {
      const descripcion = p.descripcion?.toLowerCase() ?? '';
      const codigo = p.codigoProducto?.toLowerCase() ?? '';
      const unidad = p.unidadMedida ?? '';
      const tipoItem = p.servicioProducto?.toString() ?? '';

      const filtroDescripcion = formProductos.descripcion
        ? descripcion.includes(formProductos.descripcion.toLowerCase())
        : true;

      const filtroCodigo = formProductos.codigoProducto
        ? codigo.includes(formProductos.codigoProducto.toLowerCase())
        : true;

      const filtroUnidad = formProductos.unidadMedida
        ? unidad === formProductos.unidadMedida
        : true;

      const filtroTipoItem = formProductos.tipoItem !== ''
        ? tipoItem === formProductos.tipoItem
        : true;

      return filtroDescripcion && filtroCodigo && filtroUnidad && filtroTipoItem;
    });
  };

  //Actualizar datos filtrados
  useEffect(() => {
    setSortedData(filtrarProductos());
  }, [productos, formProductos]);

  useEffect(() => {
    acciones.gp_lp_GetProductos();
  }, []);

  const seleccionarProducto = (producto: any) => dispatch(gp_lp_SetProductoSeleccionado(producto));

  const clicEliminarProducto = (producto: any) => {
    seleccionarProducto(producto);
    dispatch(gp_lp_OpenModalEliminarProducto(true));
  };

  const clicEditarProducto = async (producto: any) => {
    await actionsEditar.gp_ep_OpenEditar(producto);
    history.push('/gestion-productos/editar-producto');
  };

  const cliControlActivarProducto = (producto: any, accion: boolean) => {
    dispatch(gp_lp_SetProductoSeleccionado({ ...producto, accionEstatus: accion }));
    dispatch(gp_lp_OpenModalEstatus(true));
  };

  const clicAsignarDesasignarSucursalProducto = async (producto: any) => {
    const newProducto = { ...producto };
    newProducto.arraySucursalesAsignadas = Array.isArray(producto?.sucursales)
      ? producto.sucursales.map((el: any) => String(el?.sucursal_idsucursal || el?.idsucursal))
      : [];
    newProducto.flagAsignacion = true;
    seleccionarProducto(newProducto);
    await acciones.gp_lp_getSucursales();
    dispatch(gp_lp_OpenModalSucursales(true));
  };

  return (
    <div className='container-white w-100' style={{ overflowX: 'auto' }}>
      <h4 className='h4-titles'>Resultados obtenidos</h4>
      <div className='tab-plane mt-16' style={{ overflowX: 'auto' }}>
        <table className='tlu-table-main-responsive tlu-responsive-table-main td-left table-pointer'>
          <thead>
            <tr>
              <td>Acciones</td>
              <td>
                Sucursales{' '}
                <FilterButton data={sortedData} keyName='sucursal' state={setSortedData} />
              </td>
              <td>
                Cód. Prod. (Inventario){' '}
                <FilterButton data={sortedData} keyName='codigoProducto' state={setSortedData} />
              </td>
              <td>
                Descripción{' '}
                <FilterButton data={sortedData} keyName='descripcion' state={setSortedData} />
              </td>
              <td>
                Precio unitario{' '}
                <FilterButton data={sortedData} keyName='precioUnitario' state={setSortedData} />
              </td>
              <td>
                Servicio o producto{' '}
                <FilterButton data={sortedData} keyName='servicioProducto' state={setSortedData} />
              </td>
              <td>
                Unidad de medida{' '}
                <FilterButton data={sortedData} keyName='unidadMedida' state={setSortedData} />
              </td>
              <td>
                Estado{' '}
                <FilterButton data={sortedData} keyName='activo' state={setSortedData} />
              </td>
            </tr>
          </thead>
          <tbody>
            {sortedData.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', fontWeight: 500, fontSize: 20, padding: '1%' }}>
                  Sin datos disponibles.
                </td>
              </tr>
            ) : (
              currentItems.map((producto, index) => (
                <tr key={index} style={{ cursor: 'pointer' }} onClick={() => { seleccionarProducto(producto); history.push('/gestion-productos/detalle-producto'); }}>
                  <td data-label="Acciones" className="table-td">
                    <Tooltip title="Eliminar producto" arrow>
                      <button className="table-action" onClick={e => { e.stopPropagation(); clicEliminarProducto(producto); }}>
                        <img src={Recycle} alt="Eliminar Producto" className="table-img-action" />
                      </button>
                    </Tooltip>
                    <Tooltip title={producto?.activo === "Activo" ? "Desactivar" : "Activar"} arrow>
                      <button className="table-action" onClick={e => { e.stopPropagation(); cliControlActivarProducto(producto, producto?.activo === "Activo"); }}>
                        <img src={producto?.activo === "Activo" ? Open_Eye : Close_Eye} alt="Estado Producto" className="table-img-action" />
                      </button>
                    </Tooltip>
                    {producto?.activo === "Activo" && (
                    <Tooltip title="Editar producto" arrow>
                      <button className="table-action" onClick={e => { e.stopPropagation(); clicEditarProducto(producto); }}>
                        <img src={Edit} alt="Editar Producto" className="table-img-action" />
                      </button>
                    </Tooltip>
                    )}
                    {producto?.activo === "Activo" && (
                      <Tooltip title="Asignar / Desasignar Sucrusales" arrow>
                        <button className="table-action" onClick={e => { e.stopPropagation(); clicAsignarDesasignarSucursalProducto(producto); }}>
                          <img src={AddHome} alt="Asignar/Desasignar sucursales" className="table-img-action" />
                        </button>
                      </Tooltip>
                    )}
                  </td>
                  <td data-label="Sucursales">{producto?.totalSucursales ?? 0}</td>
                  <td data-label="Código">{producto?.codigoProducto}</td>
                  <td data-label="Descripción">
                  <Tooltip title={producto?.descripcion || ''} arrow>
                    <span className="descripcion-celda">
                      {producto?.descripcion?.length > 50
                        ? producto.descripcion.slice(0, 50) + '...'
                        : producto.descripcion}
                    </span>
                  </Tooltip>
                </td>
                  <td data-label="Precio unitario">{producto?.precioUnitario}</td>
                  <td data-label="Servicio/Producto">{getTipoItemValor(producto.servicioProducto)}</td>
                  <td data-label="Unidad de medida">{getUnidadMedidaValor(producto.unidadMedida)}</td>
                  <td data-label="Estado">
                    <div style={{ justifyContent: 'center', width: '100%', display: 'flex' }}>
                      <div className="lista-producto-estado-activo" style={{ background: producto?.estado_color }}>
                        {producto?.activo ?? '---'}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <Pagination data={sortedData} state={setCurrentItems} items={15} />
      </div>
    </div>
  );
};

export default TableListProducto;
